import { SchedulerClinicalSpecialists } from '@lp/features/Scheduler';
import { useAuthContext } from '@lp/core/auth';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedule = () => {
  const { checkPermission } = useAuthContext();
  const readonly = !checkPermission(SchedulerPermissions.CSSchedulesWrite);

  return <SchedulerClinicalSpecialists readonly={readonly} />;
};
